import { Injectable } from '@angular/core';
import { AppHttpClient } from './app-http-client.service';

@Injectable({
  providedIn: 'root'
})
export class MiscellaneousService {

  constructor(
    public http : AppHttpClient
  ) { }

  /**
   * Lists the admin-maintained template files. The certification requirements page uses
   * this rather than rules-files so it shows the same documents the applications and the
   * admin UI use, instead of a separate set discovered by S3 filename convention.
   */
  getTemplateFiles(){
    return this.http.get('template-files');
  }

  downloadTemplateFile(templateFileId: string){
    return this.http.get(`template-files?templateFileId=${templateFileId}&download=true`);
  }

  getUserGuides(){
    return this.http.get('user-guides');
  }

  getTemplateFileContent(approach: string, templateType: string){
    return this.http.get(`template-files?approach=${approach}&templateType=${templateType}&download=true`);
  }
}
